import AddPage from './AddPage.js'
import { BasePage as CngBasePage } from 'cng-web-lib'
import EditPage from './EditPage.js'
import React from 'react'
import TablePage from './TablePage.js'
import ViewPage from './ViewPage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'
import A6TranslationProvider from './contexts/A6TranslationContext.js'

function WrappedTablePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage renderPage={(showSnackbar) => (
      <A6TranslationProvider>
        <TablePage showNotification={showSnackbar} {...props} />
      </A6TranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedAddPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage renderPage={(showSnackbar) => (
      <A6TranslationProvider>
        <AddPage showNotification={showSnackbar} {...props} />
      </A6TranslationProvider>
    )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedEditPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage renderPage={(showSnackbar) => (
      <A6TranslationProvider>
        <EditPage showNotification={showSnackbar} {...props} />
      </A6TranslationProvider>
    )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedViewPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage renderPage={(showSnackbar) => (
      <A6TranslationProvider>
        <ViewPage showNotification={showSnackbar} {...props} />
      </A6TranslationProvider>
    )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedAddPage as AddPage,
  WrappedEditPage as EditPage,
  WrappedViewPage as ViewPage,
  WrappedTablePage as TablePage
}
